<template>
  <div class="body-container add-policy-list">
    <div class="page-title">加保记录</div>
    <div class="list-content" v-if="list.length">
      <div class="list-item head">
        <div>序号</div>
        <div>加保时间</div>
        <div>加保保费(元)</div>
        <div>操作</div>
      </div>
      <div class="list-item" v-for="(item, index) in list" :key="index">
        <div>{{index+1}}</div>
        <div>{{item.addPolicyDate | timeSub(10)}}</div>
        <!-- addAmount是保额 addPremium保费-->
        <div>{{item.addPremium}}</div>
        <div>
          <div class="btn" v-if="item.addPolicyUrl" @click="jumpPage(item.addPolicyUrl)">查看批单</div>
          <div v-else>-</div>
        </div>
      </div>
    </div>
    <div class="null" v-if="list.length<=0&&!listLoading">
      <img class="null-img" src="@static/images/null.png">
      <span class="null-text">暂无内容</span>
    </div>
  </div>
</template>
<script>
//当前实例组件
import {pageTools,common} from "@/api/mixins";
export default {
  mixins:[pageTools,common],
  data: () => ({
    listAll:true,
    policyNo:"",
  }),
  mounted() {
    this.policyNo = this.$route.query.policyNo;
    this.initListAjax("/api/addPolicy/recordList/"+this.policyNo)
  },
  methods: {
  },
};
</script>
<style lang="scss" scoped>
@import "./addPolicyList.scss";
</style>
